import { render } from "./ReferenciaForm.vue?vue&type=template&id=3fe27205&scoped=true"
import script from "./ReferenciaForm.vue?vue&type=script&lang=js"
export * from "./ReferenciaForm.vue?vue&type=script&lang=js"

import "./ReferenciaForm.vue?vue&type=style&index=0&id=3fe27205&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe27205"]])

export default __exports__